'use client';

import { useCallback, ReactNode } from 'react';
import dynamic from 'next/dynamic';

import CTAButton from '@/components/ui/buttons/CTAButton/CTAButton';
import { useModal } from '@/lib/hooks/useModal';
import type { Dictionary } from '@/content/i18n/schema';

const PromoFormModalContent = dynamic(
  () =>
    import('@/components/features/PromoFormModal/PromoFormModalContent').then(
      (mod) => mod.PromoFormModalContent
    ),
  { ssr: false }
);

interface DMManagerButtonProps {
  children: ReactNode;
  formCopy: Dictionary['promoInfo']['form'];
  plan?: {
    id: string;
    name: string;
    price: string;
  };
  isPersonalPlan?: boolean;
  streams?: number;
  cost?: number;
  stripeCheckout?: { priceId: string; locale: string };
  variant?: 'orange' | 'white' | 'gray' | null;
  iconId?: string;
  className?: string;
  disabled?: boolean;
}

export default function DMManagerButton({
  children,
  formCopy,
  plan,
  isPersonalPlan,
  streams,
  cost,
  stripeCheckout,
  variant,
  iconId,
  className,
  disabled,
}: DMManagerButtonProps) {
  const { setModal } = useModal();

  const openForm = useCallback(() => {
    setModal(
      <PromoFormModalContent
        onClose={() => setModal(null)}
        copy={formCopy}
        plan={plan}
        isPersonalPlan={isPersonalPlan}
        streams={streams}
        cost={cost}
        stripeCheckout={stripeCheckout}
      />
    );
  }, [setModal, formCopy, plan, isPersonalPlan, streams, cost, stripeCheckout]);

  return (
    <CTAButton
      mode="button"
      variant={variant}
      iconId={iconId}
      className={className}
      onClick={openForm}
      disabled={disabled}
    >
      {children}
    </CTAButton>
  );
}
